import type { HeroId } from '../core';

/**
 * Full-body poses. `smug` is the old name for the boast painting.
 * Texture keys map it onto the boast file so trick popups keep their wink.
 */
export type HeroPose = 'idle' | 'cheer' | 'smug' | 'boast' | 'dismay' | 'power' | 'hurt';

export const HERO_POSES: readonly HeroPose[] = ['idle', 'cheer', 'boast', 'dismay', 'power', 'hurt'];

/**
 * The title row. Pip, Bramble, Cleo, and Otto stay in the original line.
 * The rest of the cast lives on the hub, the road, and the select screen.
 */
export const TITLE_CAST: readonly HeroId[] = ['pip', 'bramble', 'cleo', 'otto'];

/** Class by class: guardians, infiltration, stealth, tidecallers, then grove. */
export const HERO_ORDER: readonly HeroId[] = [
  'pip',
  'bruno',
  'tuck',
  'bramble',
  'thistle',
  'marlow',
  'cleo',
  'wren',
  'juniper',
  'otto',
  'lumi',
  'barley',
  'fern',
  'posy',
  'dash',
];

/**
 * The first four have a painting for every pose. Later critters reuse the
 * idle cutout for cheer, boast, dismay, power, and hurt.
 */
export const PAINTED_POSES: ReadonlySet<HeroId> = new Set(['pip', 'bramble', 'cleo', 'otto']);

/** Portrait labels. Bramble is the badger of the Thistlewood cast. */
export const DISPLAY_SPECIES: Record<HeroId, string> = {
  pip: 'Hedgehog',
  bruno: 'Bear Cub',
  tuck: 'Tortoise',
  bramble: 'Badger',
  thistle: 'Badger',
  marlow: 'Mole',
  cleo: 'Fox',
  wren: 'Owl',
  juniper: 'Raccoon',
  otto: 'Otter',
  lumi: 'Swanling',
  barley: 'Beaver',
  fern: 'Dormouse',
  posy: 'Bunny',
  dash: 'Squirrel',
};

export function critterTitle(id: HeroId, name: string): string {
  return `${name} the ${DISPLAY_SPECIES[id]}`;
}
